const DATA_AI_VALUE_LOOP_EN = {
  heading: 'Capabilities only create value when they ship.',
  lead: 'The AI Value Loop: a structured method to make sure your AI investments actually deliver.',
  body:
    'The capabilities above are powerful, but technology alone doesn\u2019t create business value and most AI projects never make it to production. To turn them into working AI solutions, in production, with outcomes you can measure, the AI Value Loop is the method we use, executed by our Forward Deployed Engineers.',
  centerLabel: 'AI Value Loop',
  centerSubtitle: [
    'Run by our Forward Deployed Engineers',
    'embedded in your team',
  ],
  steps: [
    { id: 'discover', title: 'Discover' },
    { id: 'build', title: 'Build' },
    { id: 'deploy', title: 'Deploy' },
    { id: 'operate', title: 'Operate & Scale', multiline: true },
  ],
  cta: {
    label: 'Know How it Works',
    href: '/en/enterprise-ai/',
  },
}

const DATA_AI_VALUE_LOOP_PT = {
  heading: 'As capacidades só criam valor quando chegam a produção.',
  lead:
    'O AI Value Loop: um método estruturado para garantir que os seus investimentos em IA geram resultados.',
  body:
    'As capacidades acima são poderosas, mas a tecnologia, por si só, não cria valor de negócio, e a maioria dos projetos de IA nunca chega a produção. Para os transformar em soluções reais, em produção, com resultados mensuráveis, usamos o AI Value Loop, executado pelos nossos Forward Deployed Engineers.',
  centerLabel: 'AI Value Loop',
  centerSubtitle: [
    'Operado pelos nossos Forward Deployed Engineers,',
    'integrados na sua equipa',
  ],
  steps: [
    { id: 'discover', title: 'Descobrir' },
    { id: 'build', title: 'Construir' },
    { id: 'deploy', title: 'Implementar' },
    { id: 'operate', title: 'Operar e Escalar', multiline: true },
  ],
  cta: {
    label: 'Saiba como funciona',
    href: '/ia-empresarial/',
  },
}

export const getDataAiValueLoopContent = lang =>
  lang === 'pt' ? DATA_AI_VALUE_LOOP_PT : DATA_AI_VALUE_LOOP_EN
